







import Vue from 'vue'
import { PropValidator } from 'vue/types/options'  // using "as () => T" seems enough
import { IDevice, IVW } from '@/types/model'
import { setInterval } from 'timers'
import { getVwTxColor } from '@/vw_algorithm'
import { thumb_size_t } from '@/store/modules/pref'
import { geometry_size_t, screen_style_t } from '@/vw_algorithm'

export default Vue.extend({
  model: {
    prop: 'device'
  },
  props: {
    thumbSize: {
      type: String,
      default: 'md'
    } as PropValidator<thumb_size_t>,
    /**
     * width and height has higher priority than thumbSize.
     * Don't specify width and height simultaneously.
     */
    width: {
      type: Number,
      default: 0
    },
    /**
     *  width and height has higher priority than thumbSize
     * Don't specify width and height simultaneously.
     */
    height: {
      type: Number ,
      defualt: 0
    },
    showIndexes: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Number,
    },
    rows: {
      type: Number,
    }
  },
  computed: {
    rootSize (): geometry_size_t {
      if (this.width) {
        return { width: this.width, height: this.width * 5 / 9 }
      } else if (this.height) {
        return { width: this.height * 9 / 5, height: this.height }
      } else {
        let w = 0
        switch (this.thumbSize) {
          case 'xs': w = 40; break
          case 'sm': w = 90; break
          case 'md': w = 110; break
          case 'lg': w = 170; break
          case 'xl': w = 240; break
        }
        return { width: w, height: w * 5 / 9 }
      }
    },
    rootStyle (): string {
      return `width:${this.rootSize.width}px;height:${this.rootSize.height}px;`
    },
    screensContainerSize (): geometry_size_t {
      return {
        width: this.screenSize.width * this.columns,
        height: this.screenSize.height * this.rows
      }
    },
    screensContainerStyle (): string {
      return `width:${this.screensContainerSize.width}px;height:${this.screensContainerSize.height}px;`
    },
    screenSize (): geometry_size_t {
      if (this.columns > this.rows) {
        const w = this.rootSize.width / this.columns
        const h = w * 5 / 9
        return { width: w, height: h }
      } else {
        const h = this.rootSize.height / this.rows
        const w = h * 9 / 5
        return { width: w, height: h }
      }
    },
    screenCommonStyle (): string {
      return `width:${this.screenSize.width}px;height:${this.screenSize.height}px;`
    },
    screenList (): screen_style_t[] {
      return Array(this.columns * this.rows).fill(0).map((_, index) => {
        const tmp: screen_style_t = {
          displayIndex: index + 1,
          style: this.screenCommonStyle,
          clickable: false,
          hasBezelSet: false,
          rxSelected: false,
          osd: 0,
        }
        return tmp
      })
    },
  },
})
